import { type RefObject, useEffect, useState } from 'react';

export const useMouseHover = (
  ref: RefObject<HTMLElement | SVGElement | null>,
): boolean => {
  const container = ref?.current;
  const [hover, setHover] = useState(false);

  useEffect(() => {
    const onMouseEnter = () => setHover(true);
    const onMouseLeave = () => setHover(false);

    container?.addEventListener('mouseenter', onMouseEnter, {
      passive: true,
    });
    container?.addEventListener('mouseleave', onMouseLeave, {
      passive: true,
    });
    container?.addEventListener('touchstart', onMouseEnter, {
      passive: true,
    });
    container?.addEventListener('touchend', onMouseLeave, {
      passive: true,
    });

    return () => {
      container?.removeEventListener('mouseenter', onMouseEnter);
      container?.removeEventListener('mouseleave', onMouseLeave);
      container?.removeEventListener('touchstart', onMouseLeave);
      container?.removeEventListener('touchend', onMouseLeave);
    };
  }, [container]);

  return hover;
};
